
<script>
import { productService , orderService , customerService } from "../../services";
import Multiselect from "vue-multiselect";
import { decimalNumber, NotZeroNumber } from "../../Helper/formValidation";
import {
  required,requiredIf
} from "vuelidate/lib/validators";

export default {
  components: { Multiselect, productService, orderService, customerService },
  props: ["cust_data"],
  data() {
    return {
      customers: {
        user_id: this.cust_data.user_id,
      },
      products: [],
      isLoading: false,
      error: [],
      b2b_customer_chk: [],
      b2b_customers: [{ product: "", sub_product: "", min_qty: 1, price: "", subProducts: [] }],
      typeform: {
        b2b_customers: [{ product: "", sub_product: "", min_qty: 1, price: "", subProducts: [] }],
      },
    };
  },
  validations: {
    typeform: {
      b2b_customers: {
        $each: {
          product: {
              required: requiredIf(function (form) {
                  return (
                      (form.sub_product != "" || form.price != "")
                  );
              }),
          },
          sub_product:{
              required: requiredIf(function (form) {
                  return (
                      (form.product != "" || form.price != "")
                  );
              }),
          },
          min_qty: {
              required: requiredIf(function (form) {
                  return (
                      (form.product != "" || form.price != "")
                  );
              }),
          },
          price: {
              required: requiredIf(function (form) {
                  return (
                      (form.product != "" || form.sub_product != "")
                  );
              }),
          },
        },
      },
    },
  },
  mounted() {
    this.asyncFindProduct({ search: "" });
    this.fetchProductsAndDetails();
  },
  methods: {
    decimalNumber,
    NotZeroNumber,
    customLabel({ sub_product_name, material }) {
      if (sub_product_name == "" || sub_product_name == 'undefined') return false;
      return `${sub_product_name} (${material})`
    },
    asyncFindProduct(query) {
      this.isLoading = true;
      productService
        .getSearchProductByNameApi({ query })
        .then((response) => {
          this.products = response.data.result.sort((a, b) => {
            return a.item_name.localeCompare(b.item_name);
          });
          this.isLoading = false;
        });
    },
    getSubProduct(product, index) {
      var product_id = product.id;
      this.typeform.b2b_customers[index].subProducts = [];
      this.typeform.b2b_customers[index].sub_product = "";
      this.isLoading = true;
      orderService
        .getVariantByProduct({ product_id: product_id, customer_type: "Business" })
        .then((response) => {
          this.typeform.b2b_customers[index].subProducts = response.data.result.sort((a, b) => {
            return a.sub_product_name.localeCompare(b.sub_product_name);
          });
          this.isLoading = false;
        });
    },
    AddField() {
      this.typeform.b2b_customers.push({ product: "", sub_product: "", min_qty: 1, price: "", subProducts: [] });
    },
    remove_field(index) {
      this.typeform.b2b_customers.splice(index, 1);
      this.error.splice(index, 1);
    },
    checkSubProduct(val, i) {
      var id = val.id;
      let chk = this.b2b_customer_chk.findIndex((data) => data == id);
      this.error[i] = false;
      if (chk == -1) {
        if (this.b2b_customer_chk[i] != "") {
          this.b2b_customer_chk.splice(i, 1, id);
        } else {
          this.b2b_customer_chk.push(id);
        }
      } else {
        this.error[i] = true;
        return false;
      }
      if (this.error[i] == true) {
        return false;
      }
    },
    async fetchProductsAndDetails() {
      try {
        this.isLoading = true;
        const [productsResponse, customerDetailsResponse] = await Promise.all([
          productService.getSearchProductByNameApi({ query: "" }),
          customerService.getB2bCutomerProducts({ id: this.cust_data.user_id }),
        ]);

        this.products = productsResponse.data.result.sort((a, b) =>
          a.item_name.localeCompare(b.item_name)
        );
        console.log(customerDetailsResponse);

        if (!customerDetailsResponse.data || customerDetailsResponse.data.length === 0) {
          this.typeform.b2b_customers = [{
            product: "",
            sub_product: "",
            min_qty: 1,
            price: "",
            subProducts: [],
          }];
        } else {
          const customerData = await Promise.all(
            customerDetailsResponse.data.map(async (item) => {
              const subProductsResponse = await orderService.getVariantByProduct({
                product_id: item.product_id,
                customer_type: "Business",
              });

              const subProducts = subProductsResponse.data.result.sort((a, b) =>
                a.sub_product_name.localeCompare(b.sub_product_name)
              );

              return {
                product: this.products.find((p) => p.id === item.product_id) || { id: item.product_id, item_name: "Unknown" },
                sub_product: subProducts.find((sp) => sp.id === item.sub_product) || { id: item.sub_product, sub_product_name: "Unknown", material: "Unknown" },
                min_qty: item.min_qty,
                price: item.price,
                subProducts: subProducts,
              };
            })
          );

          this.typeform.b2b_customers = customerData;
          customerData.forEach((item, key) => {
            if (item.sub_product) {
              this.b2b_customer_chk.push(item.sub_product.id);
              this.error[key] = false;
            }
          }); // There are customers, show the form
        }
      } finally {
        this.isLoading = false;
      }
    },
    typeForm(e) {
      this.$v.$touch(); // Trigger validation
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }
      this.isDisabled = true;
      customerService.individualSubProductSave({ id: this.cust_data.user_id, ...this.typeform }).then((response) => {
        this.$router.push({ name: "customer-list" });
        this.isDisabled = false;
      });
    },
    showAddForm() {
      this.showForm = true;  // Show the form when the "Add" button is clicked
    },
  },
};
</script>

<template>
  <!-- B2b product Start -->
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="typeForm">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title"></h4>
            <p class="card-title-desc"></p>
            <div class="row" v-for="(v, i) in $v.typeform.b2b_customers.$each.$iter" :key="i">
             <div class="col-sm-6">
                 <div class="form-group">
                 <label>{{ trans.trans("__JSON__.Product") }}</label>
                 <multiselect
                     v-model="v.product.$model"
                     id="product"
                     label="item_name"
                     track-by="id"
                     :placeholder="trans.get('__JSON__.Type to Search Product')"
                     open-direction="bottom"
                     :options="products"
                     :multiple="false"
                     :searchable="true"
                     :loading="isLoading"
                     :internal-search="true"
                     :close-on-select="true"
                     :clear-on-select="true"
                     :max-height="600"
                     :show-no-results="true"
                     :hide-selected="true"
                     @search-change="asyncFindProduct"
                     @select="(product) => getSubProduct(product, i)"
                     :class="{
                         'is-invalid': v.product.$error,
                     }"
                     >
                     <span
                     slot="noResult"
                     >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                 </multiselect>
                 <div v-if="v.product.$error" class="form-error">
                     <span v-if="!v.product.required">{{
                         trans.get("__JSON__.Please select product")
                     }}</span>
                 </div>
                 </div>
             </div>
 
             <div class="col-sm-6">
             <div class="form-group">
                 <label>{{ trans.trans("__JSON__.Sub Product") }}</label>
                 <multiselect
                 v-model="v.sub_product.$model"
                 id="sub_product"
                 label="sub_product_name"
                 track-by="id"
                 :placeholder="trans.get('__JSON__.Sub Product')"
                 open-direction="bottom"
                 :options="typeform.b2b_customers[i].subProducts"
                 :multiple="false"
                 :searchable="true"
                 :loading="isLoading"
                 :internal-search="false"
                 :close-on-select="true"
                 :clear-on-select="true"
                 :max-height="600"
                 :show-no-results="true"
                 :hide-selected="true"
                 :custom-label="customLabel"
                 :class="{
                     'is-invalid': v.sub_product.$error,
                 }"
                 @select="checkSubProduct($event, i)"
                 >
                 <span
                 slot="noResult"
                 >{{ trans.get('__JSON__.Oops! No elements found. Consider changing the search query') }}.</span>
                 </multiselect>
                 <div v-if="error[i] == true && !v.sub_product.$error">
                     <span class="error-msg">{{
                         trans.get("__JSON__.This sub product already selected")
                     }}</span>
                 </div>
                 <div v-if="v.sub_product.$error" class="form-error">
                     <span v-if="!v.sub_product.required">{{
                         trans.get("__JSON__.Please select SubProduct")
                     }}</span>
                 </div>
             </div>
             </div>
 
 
             <div class="col-sm-2">
             <div class="form-group">
                 <label>{{ trans.trans("__JSON__.Min. Quantity") }}</label>
                 <input
                 maxlength="5"
                 minlength="1"
                 v-model="v.min_qty.$model"
                 type="text"
                 class="form-control"
                 :placeholder="trans.trans('__JSON__.Min. Quantity')"
                 name="min_qty[]"
                 @keypress="NotZeroNumber($event,5)"
                 :class="{
                     'is-invalid': v.min_qty.$error,
                 }"
                 />
             </div>
             <div v-if="v.min_qty.$error" class="form-error">
               <span v-if="!v.min_qty.required">{{
                 trans.get("__JSON__.Please add quantity")
               }}</span>
             </div>
             </div>
             <div class="col-sm-2">
             <div class="form-group">
                 <label>{{ trans.trans("__JSON__.Price") }}</label>
                 <input
                 maxlength="8"
                 minlength="1"
                 v-model="v.price.$model"
                 type="text"
                 class="form-control"
                 :placeholder="trans.trans('__JSON__.Price')"
                 name="price[]"
                 @keypress="decimalNumber"
                 :class="{
                     'is-invalid': v.price.$error,
                 }"
                 />
             </div>
             <div v-if="v.price.$error" class="form-error">
               <span v-if="!v.price.required">{{
                 trans.get("__JSON__.Please add price")
               }}</span>
             </div>
             </div>
             <div class="col-md-2">
             <h6>&nbsp;</h6>
             <button
                 class="btn btn-primary btn-sm btn-rounded"
                 @click.prevent="AddField()"
             >
                 +</button
             >&nbsp;&nbsp;
             <button
               class="btn btn-danger btn-sm btn-rounded"
               v-if="i != 0"
               @click.prevent="remove_field(i)"
             >
                 -
             </button>
             </div>
         </div>
            <div class="row">
              <div class="col-sm-6">
                <button type="submit" class="btn btn-primary mr-1 mt-3">
                  {{ trans.get("__JSON__.Update") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- B2b product End -->
  <!-- end row -->
 </template>
 
 <style>
 </style>
 

<style>
</style>